import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function initTilesCarousel() {
  const sliderElements = document.querySelectorAll(".tiles-carousel");

  if (!sliderElements.length > 0) return;

  sliderElements.forEach((el) => {
    const sliderContainer = el.querySelector(
      ".swiper-container:not(.swiper-initialized):not(.swiper-disabled)"
    );
    const btnNext = el.querySelector(".swiper-button-next");
    const btnPrev = el.querySelector(".swiper-button-prev");
    const pagination = el.querySelector(".swiper-pagination");

    if (!sliderContainer) return;

    const slider = new Swiper(sliderContainer, {
      loop: false,
      spaceBetween: 16,
      centeredSlidesBounds: false,
      centeredSlides: false,
      slidesPerView: 1.1,
      observeParents: true,
      watchSlidesProgress: true,
      a11y: true,
      keyboardControl: true,
      autoHeight: false,
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      pagination: {
        el: pagination,
        type: "progressbar",
      },
      breakpoints: {
        650: {
          slidesPerView: 2.8,
          centeredSlides: false,
          centeredSlidesBounds: false,
          spaceBetween: 24,
        },

        1024: {
          slidesPerView: 3.3,
          centeredSlides: false,
          centeredSlidesBounds: false,
          spaceBetween: 32,
        },
      },
      on: {
        slideChange: function () {
          if (this.isEnd) {
            this.el.classList.add("is-end");
          } else {
            this.el.classList.remove("is-end");
          }
        },
      },
    });
  });
}

window.addEventListener("DOMContentLoaded", () => {
  initTilesCarousel();
});
